import { VAutocomplete } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { COMPANY_SELECT } from '../type_name'
import commonMixins from './commonMixins'
import { mapGetters } from 'vuex'
export default {
    name: COMPANY_SELECT,
    mixins: [ commonMixins ],
    computed: {
        ...mapGetters('async', ['companies', 'companies_hash']),
        items() {
            
            const { 
                disabled_items = [],
                item_text_key = 'short_name',
                handle_compnay_list
             } = this.field
            const disabled_items_hash = disabled_items.reduce((total, item) => {
                total[item] = true
                return total
            }, {})
            const list = this.companies
            .map(item => ({
                disabled: !!disabled_items_hash[item.id],
                value: item.id,
                text: item[item_text_key]
            }))
            if (handle_compnay_list) {
                return handle_compnay_list(list)
            }
            return list
        },
        items_hash() {
           return (this.items || []).reduce((total, item) => {
               if (!item) {
                return total
               }
               const id = item.value
               const current = this.companies_hash[id] || {}
               total[id] = {...current, ...item}
                return total
           }, {})
        }
    },

    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,handle_compnay_list,
             key,
             _type = 'text',
             blur = defaultFun,
             change,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        params.type = _type
        return h(VAutocomplete, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value[key],
                items:this.items
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    change && change(data, (this.items_hash || {})[data])
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
            }
        })
    }
}